import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";
import { MESSAGE_TEMPLATE_QUERY_KEY } from "./message-template.query.key";

export const queryOptions_message_template_variables = () =>
  queryOptions({
    queryKey: [MESSAGE_TEMPLATE_QUERY_KEY, "variables"] as const,
    queryFn: () => extractionWrapper(api.messageTemplateVariable.getAll()),
    staleTime: 5 * 60 * 1000, // Variables don't change often, cache for 5 minutes
  });

export const useMessageTemplateVariables = () => {
  return useQuery(queryOptions_message_template_variables());
};
